import React from 'react'
import { Collapse, Tabs, Icon, Radio, Row } from "antd";
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from "styled-components";

// Components
import Container from "../../../containers/Container";
import typo from "../../../constants/dictionaries"
import helper from "../../../helper/helper"
import columns from './colums';
import Table from "../../../components/Table";
import BieuDo_VTQT from "./BieuDoTramQT"
import { Scrollbars } from 'react-custom-scrollbars';
import Button from "../../../components/Buttons";
import constants from "../../../constants/constant"
import Api_tnn from "../../../api/api.tnn"
import message from "../../../components/Messages";
import KQQTModal from './routerKQQTModal'
const { Panel } = Collapse;
const { TabPane } = Tabs;
const compare = (a, b) => {
    if (a.id < b.id) {
        return 1;
    }
    if (a.id > b.id) {
        return -1;
    }
    return 0;
}
class MauQTModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            changeBieudo: 1,
            data_info_mauQT: [],
            data_doituong: [],
            doituongQT: undefined,
            isEditModalOpen: false,
            selectedRow: undefined

        }
    }

    componentDidMount() {
        this.GetTPMT_Exist()
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { idTramQuanTrac } = this.props
        const { changeBieudo } = this.state
        if (prevProps.idTramQuanTrac !== idTramQuanTrac || prevState.changeBieudo !== changeBieudo) {
            this.GetTPMT_Exist()
        }
    }

    GetTPMT_Exist = () => {
        const { idTramQuanTrac, apiGetTPMT_Exist } = this.props;
        apiGetTPMT_Exist({ token: this.props.user.access_token, id_tramqt: idTramQuanTrac })
            .then(res => {
                let data_doituong = []
                res.length > 0 && res.map((vl, idx) => {
                    let doituong = constants.THANH_PHAN_MOI_TRUONG.filter(x => x.id === vl)
                    data_doituong.push(doituong[0])
                })
                this.setState({
                    data_doituong: data_doituong.sort(compare),
                    doituongQT: data_doituong.length > 0 ? data_doituong[0].id : undefined
                })
                data_doituong.length > 0 && this.GetMauQTs_By_TramQT(idTramQuanTrac, data_doituong[0].id)
            })
            .catch(err => {
                message.error(err.message)
            })
    };

    GetMauQTs_By_TramQT = (id_TramQT, doiTuongQT) => {
        const { apiGetMauQT_by_Tram } = this.props
        apiGetMauQT_by_Tram({ token: this.props.user.access_token, id_tramqt: id_TramQT, tpmt_ma: doiTuongQT })
            .then((res) => {
                let data = []
                res && res.map((vl, idx) => {
                    let data_mau = vl.data && vl.data.map((item, idx) => ({ ...item, dot: vl.dot, nam: vl.nam }))
                    data = data.concat(data_mau);
                })
                this.setState({
                    data_info_mauQT: data,
                })
            })
            .catch((err) => {
                message.error(err.message);
            });
    };


    showDetail = (row) => {
        this.setState({
            selectedRow: row,
            isEditModalOpen: true
        })
    }
    handleCloseModal = () => {
        this.setState({
            isEditModalOpen: false,
            selectedRow: null
        })
    };
    onChangeTabs = (id) => {
        const { idTramQuanTrac } = this.props
        this.setState({ doituongQT: Number(id) })
        this.GetMauQTs_By_TramQT(idTramQuanTrac, Number(id))
    }
    render() {
        const { idTramQuanTrac, apiGiaTriTimeLine, phanloai, apiSoLan_VuotNguong, apiGetTPMT_Exist, apiThongSo_Exist } = this.props
        const { changeBieudo, data_doituong, data_info_mauQT, doituongQT, selectedRow, isEditModalOpen } = this.state
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
        };
        return (
            <Container>
                {data_doituong && data_doituong.length > 0 ?
                    <div>
                        <Row type='flex' justify='end'>
                            <Radio.Group name="radiogroup" defaultValue={1} >
                                <Radio style={radioStyle} value={1} onChange={(e) => e.target.value === 1 && this.setState({ changeBieudo: 1 })}>{typo.cscore_info_mau_QT}</Radio>
                                <Radio style={radioStyle} value={2} onChange={(e) => e.target.value === 2 && this.setState({ changeBieudo: 2 })}>{typo.cscore_chart}</Radio>
                            </Radio.Group>
                        </Row>
                        <div className="mt-20"></div>
                        {changeBieudo === 1 &&
                            <div>
                                <Tabs tabPosition='left' onChange={this.onChangeTabs}>
                                    {data_doituong.map((vl, idx) => <TabPane tab={vl.ten} key={vl.id}>
                                        <Scrollbars autoHeight autoHeightMax={500} autoHeightMin={100} autoHide autoHideTimeout={1000} autoHideDuration={200}>
                                            <Table
                                                columns={columns({ showDetail: this.showDetail })}
                                                dataSource={helper.addSttToDataSource(data_info_mauQT)}
                                                pagination={false}
                                            />
                                        </Scrollbars>
                                    </TabPane>)}
                                </Tabs>
                            </div>}
                        {changeBieudo === 2 &&
                            <div style={{ minHeight: 500 }}>
                                <BieuDo_VTQT
                                    idTramQT={idTramQuanTrac}
                                    apiSoLan_VuotNguong={apiSoLan_VuotNguong}
                                    apiGetTPMT_Exist={apiGetTPMT_Exist}
                                    apiThongSo_Exist={apiThongSo_Exist}
                                    apiGiaTriTimeLine={apiGiaTriTimeLine}
                                />
                            </div>}
                    </div>
                    :
                    <div style={{ color: "#cfcdcd", textAlign: "center" }}>Không có dữ liệu</div>}
                {isEditModalOpen &&
                    <KQQTModal
                        mode="edit"
                        view="view"
                        initialValues={selectedRow}
                        isOpen={isEditModalOpen}
                        handleCancel={this.handleCloseModal}
                        handleOk={() => { }}
                        isEdit={true}
                        nam={selectedRow.nam}
                        phanloai={phanloai}
                    />}
            </Container>
        )
    }
}

MauQTModal.propTypes = {
    handleCloseModal: PropTypes.func.isRequired,
};


const mapStateToProps = (state) => ({
    user: state.oidc.user
});

export default connect(mapStateToProps)(MauQTModal)